import { render, staticRenderFns } from "./MatrixReportPage.vue?vue&type=template&id=dd3654d4"
import script from "./MatrixReportPage.vue?vue&type=script&lang=js"
export * from "./MatrixReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports